import { logDebugging } from '../../../log/logger';
import IMAPlayerController from './ima.player.controller';
import IMAPlayerView from './ima.player.view';

export default class IMAPlayerManager {
  constructor(idComponent, cid) {
    this.idComponent = idComponent;
    this.viewComponent = new IMAPlayerView(this.idComponent, cid);
    this.controllerComponent = new IMAPlayerController(this.viewComponent, cid);
  }

  load(sspwrapper) {
    return new Promise((resolve, reject) => {
      this.controllerComponent
        .load(sspwrapper)
        .then(
          (data) => {
            if (data) {
              logDebugging('IMAPlayerManager tengo publi ', data, sspwrapper);
              resolve(data);
            } else {
              reject(data);
            }
          },
          (error) => {
            reject(error);
          },
        )
        .catch((e) => {
          logDebugging(e);
        });
    });
  }

  getEvent() {
    return this.controllerComponent.getEvent();
  }
}
